/**
 * Links into a room's page.
 *
 * Room pages open on a tab named in the address (`?tab=schedule`), which is
 * how the project's Install Schedule sends you to the same task in its room.
 * One place so a renamed tab can't leave a link pointing at nothing.
 */

/** Tabs a room page can open on — the `data-tab` keys in room-detail.ts. */
export type RoomTab = 'overview' | 'mood' | 'ba' | 'palette' | 'punch' | 'schedule';

export function roomHash(roomId: string, tab?: RoomTab): string {
  const base = `#/rooms/${encodeURIComponent(roomId)}`;
  return tab && tab !== 'overview' ? `${base}?tab=${tab}` : base;
}
